export const vacancies = [
    {
        title: 'шукаємо \nhead of beverage',
        label: 'head of beverage',
        iconVacation: '/images/iconVacation.svg',
        description:
            'Не бармен і не маркетолог, а архітектор напоїв, який бачить напій як частину бренду. У Seaters кава та зерно — зона відповідальності Head of Barista. Твоя місія — побудувати весь світ навколо неї.',
        requirements: [
            'маєш досвід у створенні напоїв (mixology / beverage R&D / bar lead)',
            'розумієш сучасні тренди — від чайної культури до low-ABV та mindful drinks',
            'вмієш мислити і як шеф, і як бренд-білдер',
            'відчуваєш баланс між смаком, технологією й емоцією',
        ],
        image: '/images/vacancies/news.svg',
    },
  {
    title: 'шукаємо \nбариста',
    label: 'barista',
    iconVacation: '/images/iconVacation.svg',
    description:
      'Ми шукаємо того, хто готовий не просто готувати каву, а створювати атмосферу веселощів, щирості та натхнення щодня. Якщо ти мрієш про місце, де можеш бути собою, розвиватися та працювати з людьми, які заряджають, — ти майже частина команди.',
    requirements: [
      'коник на каві – твоя суперсила',
      "відповідальність – твоє друге ім'я",
      "можеш зав'язати легкий small talk із будь-ким",
    ],
    image: '/images/vacancies/news.svg',
  },
  {
    title: 'шукаємо \n менеджера',
    label: 'manager',
    iconVacation: '/images/iconVacation.svg',
    description:
      'Нам потрібен супер герой, який не просто керує процесами, а створює середовище, в якому кожен відчуває підтримку, ясність і драйв. Якщо тобі близька ідея бути центром команди — чути, вирішувати, надихати та тримати все під контролем із легкістю — тобі до нас.',
    requirements: [
      'організованість та уважність до деталей',
      'досвід роботи з людьми',
      'готовність швидко навчатися',
    ],
    image: '/images/vacancies/news.svg',
  },
  {
    title: 'шукаємо \n сендвіч-мейкера',
    label: 'sandwich maker',
    iconVacation: '/images/iconVacation.svg',
    description:
      'Якщо для тебе важливо не тільки нагодувати, а й подарувати людям затишок, тепло й настрій — ми вже майже знайомі. Ми в пошуках того, хто не просто складає сендвічі, а творить смачні історії з кожного шматочка хліба та інгредієнтів.\n Тут можна бути собою, рости разом із командою, що надихає, і щодня робити прості речі з великою любов’ю.',
    requirements: ['комунікабельність', 'енергійність', 'бажання працювати в команді'],
    image: '/images/vacancies/news.svg',
  },
]
